import { assertNever, toNumber } from '@freelancer/utils';
import type {
  WebsocketOnlineOfflineStatusChangeEvent,
  WebsocketOnlineOfflineSubscribeEvent,
} from './online-offline.backend-model';
import { OnlineOfflineUserStatusValueApi } from './online-offline.backend-model';
import type { OnlineOfflineUserStatus } from './online-offline.model';
import { OnlineOfflineUserStatusValue } from './online-offline.model';

export function transformOnlineOfflineStatusType(
  status: OnlineOfflineUserStatusValueApi,
): OnlineOfflineUserStatusValue {
  switch (status) {
    case OnlineOfflineUserStatusValueApi.ONLINE:
      return OnlineOfflineUserStatusValue.ONLINE;
    case OnlineOfflineUserStatusValueApi.OFFLINE:
      return OnlineOfflineUserStatusValue.OFFLINE;
    default:
      return assertNever(status);
  }
}

export function transformOnlineOfflineStatusFetch<
  T extends keyof WebsocketOnlineOfflineSubscribeEvent['data'],
>([userId, status]: readonly [
  T,
  WebsocketOnlineOfflineSubscribeEvent['data'][T],
]): OnlineOfflineUserStatus {
  return {
    id: toNumber(userId),
    status: transformOnlineOfflineStatusType(status),
  };
}

export function transformOnlineOfflineStatusChange(
  data: WebsocketOnlineOfflineStatusChangeEvent['data'],
): OnlineOfflineUserStatus {
  return {
    id: data.user,
    status: transformOnlineOfflineStatusType(data.to),
    lastUpdatedTimestamp: data.timestamp * 1000,
  };
}
